module.exports = __webpack_public_path__ + "img/app7.0fa0f470.png";